export default __webpack_public_path__ + "static/media/q.bf880373.mp4";